var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { LitElement, css, html } from "lit";
import { property, state } from "lit/decorators.js";
import { documentCss } from "./styles.js";
export const mimeIconMap = new Map();
mimeIconMap.set('text/csv', 'spreadsheet');
mimeIconMap.set('application/pdf', 'pdf');
mimeIconMap.set('image/*', 'image');
mimeIconMap.set('application/*', 'document');
mimeIconMap.set('audio/*', 'audio');
mimeIconMap.set('video/*', 'video');
mimeIconMap.set('text/*', 'text');
export class QboFileExplorer extends LitElement {
    constructor() {
        super(...arguments);
        this.templateEndpoint = '/documents/folders';
        this.provider = null;
        this.pinned = new Set();
        this.currentFolder = null;
        //@property({ attribute: false })
        //currentProvider: string | null = null;
        this.folders = new Map();
        this.files = new Map();
        this.currentFile = null;
        this.sortBy = 'name';
        this.pattern = '*';
        this.sortDirection = 'asc';
        this.history = [];
        this.fileUpload = null;
        this.toolbarUp = null;
        this.toolbarDelete = null;
        this.selectable = null;
        this.abortController = null;
        this.mappings = [];
    }
    static { this.styles = [
        documentCss,
        css `details { padding-left: 16px; }
.sort th { cursor: pointer; }
th:nth-child(3) { text-align:right }
td:nth-child(3) { text-align:right }
th:nth-child(4) { text-align:right }
td:nth-child(4) { white-space: nowrap; text-align:right }
.asc::after,
.desc::after {
    display: inline-block;
    margin-left: 5px;
    width: 10px;
    height: 10px;
    content: '';
    background-size: contain;
    background-repeat: no-repeat;
}

.asc::after {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M7 14l5-5 5 5z"/></svg>');
}

.desc::after {
    background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg>');
}        
        `
    ]; }
    async connectedCallback() {
        super.connectedCallback();
        await this.fetchFolders(null);
        await this.fetchMappings();
    }
    async fetchMappings() {
        try {
            const response = await fetch('/documents/files/mappings', { cache: 'default' });
            if (response.ok) {
                const mappings = await response.json();
                this.mappings = mappings;
            }
            else {
                console.error('Failed to fetch mappings:', response.status, response.statusText);
            }
        }
        catch (error) {
            console.error('Error fetching /documents/files/mappings:', error);
        }
    }
    async firstUpdated() {
        this.fileUpload = this.shadowRoot?.querySelector('qbo-file');
        // this.fileUpload?.addEventListener('filedrop', (e) => this.handleFileDrop(e as CustomEvent));
        this.fileUpload?.addEventListener('uploadComplete', (e) => this.refresh());
        this.toolbarUp = this.shadowRoot?.querySelector('qbo-icon[icon="arrow-up"]');
        this.toolbarDelete = this.shadowRoot?.querySelector('qbo-icon[icon="delete"]');
        this.selectable = this.shadowRoot?.querySelector('qbo-selectable');
    }
    disconnectedCallback() {
        // this.fileUpload?.removeEventListener('filedrop', (e) => this.handleFileDrop(e as CustomEvent));
        this.fileUpload?.removeEventListener('uploadComplete', (e) => this.refresh());
    }
    async refresh() {
        if (this.currentFolder) {
            await this.fetchFiles(this.currentFolder);
            this.requestUpdate();
        }
    }
    // API call to fetch folders
    async fetchFolders(folder) {
        if (this.abortController) {
            this.abortController.abort();
        }
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        try {
            const uri = `/documents/folders/${folder?.uri?.replace('://', '/') ?? ''}`;
            const response = await fetch(uri, { signal });
            if (!response.ok) {
                throw new Error(`Failed to fetch root folders from: ${uri}`);
            }
            const folders = await response.json();
            folders.forEach(f => f['provider'] = f.uri.substring(0, f.uri.indexOf('://')));
            this.folders.set(folder, folders);
            this.requestUpdate();
        }
        catch (error) {
            if (error instanceof Error && error.name === 'AbortError') {
                console.log('fetchFolders aborted');
            }
            else {
                console.error('fetchFolders error:', error);
            }
        }
        finally {
            this.abortController = null;
        }
    }
    // API call to fetch files.
    async fetchFiles(folder) {
        if (this.abortController) {
            this.abortController.abort();
        }
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        try {
            const uri = `/documents/files/${folder.uri?.replace('://', '/')}`;
            const response = await fetch(uri, { signal });
            if (!response.ok) {
                throw new Error(`Failed to fetch root folders from: ${uri}`);
            }
            const files = await response.json();
            files.forEach(f => f['provider'] = f.uri.substring(0, f.uri.indexOf('://')));
            this.files.set(folder, files);
        }
        catch (error) {
            if (error instanceof Error && error.name === 'AbortError') {
                console.log('fetchFiles aborted');
            }
            else {
                console.error('fetchFiles error:', error);
            }
        }
        finally {
            this.abortController = null;
        }
    }
    // API call to delete files.
    async deleteFiles() {
        const paths = this.currentSelection.values;
        if (paths.length === 0)
            return;
        const response = await fetch(`/documents/files/delete`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(paths)
        });
        if (!response.ok) {
            throw new Error(`Delete files failed: ${response.statusText}`);
        }
        await this.fetchFiles(this.currentFolder);
        this.requestUpdate();
    }
    // Expand a folder. Will make an API call if required.
    async expandFolder(folder, event) {
        if (!this.folders.has(folder))
            await this.fetchFolders(folder);
    }
    // Click event handler for a folder.
    //async folderClick(event: Event) {
    //    const target = event.target as HTMLElement;
    //    const folder = target.closest('summary')?.title ?? 'unknown';
    //    if (target.tagName === 'SPAN') {
    //        console.log('show files');
    //        event.preventDefault();
    //        event.stopPropagation();
    //        if (this.files.has(folder))
    //            this.currentFolder = folder;
    //        else
    //            await this.fetchFiles(folder);
    //        return;
    //    };
    //    if (!this.folders.has(folder))
    //        await this.fetchFolders(folder);
    //    this.provider = folder.split('/')[0];
    //    console.log('toggle folder');
    //}
    // Click event handler for a file.
    async fileClick(fileInfo, event) {
        event.preventDefault();
        event.stopPropagation();
        if (fileInfo) {
            if (fileInfo.isDirectory) {
                await this.getFiles(fileInfo, event);
                if (!this.folders.has(fileInfo))
                    await this.fetchFolders(fileInfo);
            }
            else
                this.currentFile = fileInfo;
        }
        else
            this.currentFile = null;
    }
    formatDate(dateString) {
        if (!dateString)
            return null;
        const date = new Date(dateString);
        return html `${date.toLocaleDateString()} <wbr>${date.toLocaleTimeString()}`;
    }
    formatSize(size) {
        if (!size || size < 0)
            return '';
        if (size < 1024)
            return `${size} B`;
        let i = Math.floor(Math.log(size) / Math.log(1024));
        let num = size / Math.pow(1024, i);
        let round = Math.round(num * 100) / 100;
        return `${round} ${['B', 'KB', 'MB', 'GB', 'TB'][i]}`;
    }
    formatType(info) {
        if (info.isDirectory)
            return 'Folder';
        return info.mimeType?.split('/')[1] || info.mimeType;
    }
    sort(sortBy, event) {
        if (!this.currentFolder || !this.files.has(this.currentFolder))
            return;
        const column = event.target;
        if (this.sortBy === sortBy)
            this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
        else
            this.sortDirection = 'asc';
        this.sortBy = sortBy ?? this.sortBy;
        this.files.get(this.currentFolder).sort((a, b) => {
            const aValue = a[this.sortBy];
            const bValue = b[this.sortBy];
            if (aValue === bValue)
                return 0;
            let comparison = 0;
            if (typeof aValue === 'string' && typeof bValue === 'string') {
                if (!isNaN(Date.parse(aValue)) && !isNaN(Date.parse(bValue))) {
                    const aDate = new Date(aValue);
                    const bDate = new Date(bValue);
                    comparison = aDate.getTime() - bDate.getTime();
                }
                else {
                    comparison = aValue.localeCompare(bValue);
                }
            }
            else if (typeof aValue === 'number' && typeof bValue === 'number') {
                comparison = aValue - bValue;
            }
            else if (aValue instanceof Date && bValue instanceof Date) {
                comparison = aValue.getTime() - bValue.getTime();
            }
            return this.sortDirection === 'asc' ? comparison : -comparison;
        });
        const headers = this.shadowRoot?.querySelectorAll('th') ?? [];
        headers.forEach(th => th.classList.remove('asc', 'desc'));
        column.classList.add(this.sortDirection);
        this.requestUpdate();
    }
    getIconType(info) {
        if (info.isDirectory)
            return 'folder';
        if (info.mimeType === undefined)
            return 'document';
        for (let [key, value] of mimeIconMap) {
            if (value === info.mimeType)
                return mimeIconMap.get(key);
        }
        for (let [key, value] of mimeIconMap) {
            if (info.mimeType.startsWith(value))
                return mimeIconMap.get(key);
        }
        return 'document';
    }
    async getFiles(folder, event) {
        event?.preventDefault();
        event?.stopPropagation();
        if (!this.files.has(folder))
            await this.fetchFiles(folder);
        this.currentFolder = folder;
        return;
    }
    handleFileDrop(e) {
        const provider = e.detail.target.closest('*[data-provider]')?.getAttribute('data-provider');
        if (provider && this.fileUpload)
            this.fileUpload.provider = provider;
        const folder = e.detail.target.closest('*[data-folder]')?.getAttribute('data-folder');
        if (folder !== null && this.fileUpload)
            this.fileUpload.path = folder;
    }
    async up() {
        const parts = this.currentFolder?.relativePath?.split('/').filter(part => part !== "");
        if (!parts)
            return;
        const folder = `${this.currentFolder?.provider}://${parts.slice(0, parts.length - 1).join('/')}`;
        const key = Array.from(this.folders.keys()).find(key => key && key.uri === folder)
            || Array.from(this.files.keys()).find(key => key && key.uri === folder);
        if (key)
            await this.getFiles(key);
    }
    cut() {
        console.log(this.selectable);
    }
    copy() {
        console.log(this.selectable);
    }
    paste() {
        console.log(this.selectable);
    }
    selectionChange(e) {
        this.currentSelection = e.detail;
        if (this.toolbarDelete)
            this.toolbarDelete.disabled = this.currentSelection.values.length === 0;
    }
    renderFolder(folder) {
        if (!this.folders.has(folder))
            return null;
        const ui = this.folders.get(folder)?.map(f => {
            const name = f.name ?? '';
            // const path = folder ? `${folder}/${name}` : name;
            const path = `${folder?.uri?.replace('://', '/')}/${name}`;
            return html `<details data-drop>
    <summary title="${path}" @click=${(e) => this.expandFolder(f, e)}>
        <span @click=${(e) => this.getFiles(f, e)}>${f.name}<span>
    </summary>${this.renderFolder(f)}
</details>`;
        });
        return html `${ui}`;
    }
    renderFile() {
        if (this.currentFile === null || this.currentFolder === null)
            return html ``;
        const toMimeType = this.mappings.find(m => m.fromMimeType === this.currentFile.mimeType)?.toMimeType ?? this.currentFile.mimeType ?? "";
        return html `<qbo-file-viewer provider="${this.currentFile.provider}" path="${this.currentFile.relativePath}" mimetype="${toMimeType}" @close="${(e) => this.fileClick(null, e)}"></qbo-file-viewer>`;
        //        return html`
        //<article>
        //    <header>
        //        <a href="/documents/files/download/${this.currentFolder?.name}/${this.currentFile?.name}">${this.currentFile?.name}</a>
        //        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click=${(e) => this.fileClick(null, e)}></button>
        //    </header>
        //    <object data="/documents/files/view/${this.currentFolder?.name}/${this.currentFile?.name}" type="${this.currentFile?.mimeType}" width="100%" height="600px">
        //        <p>It appears you don't have a plugin for this file type. You can <a href="/documents/files/download/${this.currentFile?.relativePath}">click here to download the file.</a></p>
        //    </object>
        //</article>`
    }
    renderFiles(folder) {
        if (!this.files.has(folder))
            return;
        this.selectable?.clear();
        this.currentFolder = folder;
        if (this.fileUpload) {
            this.fileUpload.provider = folder.provider;
            this.fileUpload.path = folder.relativePath;
        }
        if (this.toolbarUp && this.currentFolder)
            this.toolbarUp.disabled = (this.currentFolder.relativePath === null || this.currentFolder.relativePath === '') ?? true;
        this.currentFile = null;
        const ui = this.files.get(folder)?.map(f => html `
<tr data-selectable="${f.uri}">
    <td><a href="${f.relativeUrl}" @click=${(e) => this.fileClick(f, e)}>${f.name}</a></td>
    <td title=${this.formatType(f)}><qbo-icon icon="${this.getIconType(f)}"></qbo-icon></td>
    <td class="date">${this.formatDate(f.lastModified)}</td>
    <td class="numeric">${this.formatSize(f.length)}</td>
</tr>`);
        return html `${ui}`;
    }
    // Tree view with detail element: https://codepen.io/mletic/pen/aGPOzQ
    renderTable() {
        return html `<table>
    <thead>
        <tr>
            <th colspan="4">
                <qbo-selectable type="button" parent="table" @change=${this.selectionChange}></qbo-selectable>
                <qbo-icon type="button" title="Up to parent folder" icon="arrow-up" @click=${this.up}></qbo-icon>
                <qbo-icon type="button" title="Cut to clipboard" icon="cut" @click=${this.cut}></qbo-icon>
                <qbo-icon type="button" title="Copy to clipboard" icon="copy" @click=${this.copy}></qbo-icon>
                <qbo-icon type="button" title="Paste from clipboard" icon="paste" @click=${this.paste}></qbo-icon>
                <qbo-icon type="button" title="Delete files" icon="delete" @click=${this.deleteFiles}></qbo-icon>
                <qbo-icon type="button" title="Upload files" icon="upload" data-qbo-file-click ></qbo-icon>
                <qbo-icon type="button" title="Refresh folder contents" icon="refresh" @click=${this.refresh}></qbo-icon>
            </th>
        </tr>
        <tr class="sort">
            <th @click=${(e) => this.sort('name', e)}>Name</th>
            <th @click=${(e) => this.sort('mimeType', e)}>Type</th>
            <th @click=${(e) => this.sort('lastModified', e)} class="date">Modified</th>
            <th @click=${(e) => this.sort('length', e)} class="numeric">Size</th>
        </tr>
    </thead>
    <tbody>
        ${this.currentFolder ? this.renderFiles(this.currentFolder) : html ``}
    </tbody>
    <tfoot>
        <tr><td colspan="4">${this.currentFolder ? this.files.get(this.currentFolder)?.length : 0} files. | ${this.formatSize(this.currentFolder ? this.files.get(this.currentFolder)?.reduce((total, doc) => total + doc.length, 0) : 0)}</td></tr>
    </tfoot>
</table>`;
    }
    render() {
        return html `
<qbo-file multiple="true" @filedrop=${(e) => this.handleFileDrop(e)}>
    <div class="qbo-explorer">
        <header>
            <select @change=${() => this.renderFolder('Local')}>
                <option>Drive:</option>
                ${this.folders.get(null)?.map(f => html `<option ?selected="${this.currentFolder?.provider && f.uri?.startsWith(this.currentFolder.provider)}">${f.name}</option>`)}
            </select>
            <input type="text" placeholder="Path" aria-label="Path" value="${this.currentFolder?.relativePath}">
            <input type="text" placeholder="Filter pattern" aria-label="Filter pattern" value="${this.pattern}">
        </header>
        <div class="qbo-folders">
            <div class="qbo-folders-pinned">
                ${this.pinned.forEach(f => html `<li>${f}</li>`)}
            </div>
            <div class="qbo-folders-all">
                ${this.renderFolder(null)}
            </div>
        </div>
        <qbo-resize></qbo-resize>
        <div class="qbo-files" data-drop data-provider=${this.currentFolder?.provider} data-folder=${this.currentFolder?.relativePath}>
            ${this.currentFile ? this.renderFile() : this.renderTable()}
        </div>
    </div>
</qbo-file>`;
    }
}
__decorate([
    property(),
    __metadata("design:type", String)
], QboFileExplorer.prototype, "templateEndpoint", void 0);
__decorate([
    property(),
    __metadata("design:type", Object)
], QboFileExplorer.prototype, "provider", void 0);
__decorate([
    property(),
    __metadata("design:type", Set)
], QboFileExplorer.prototype, "pinned", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Object)
], QboFileExplorer.prototype, "currentFolder", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Map)
], QboFileExplorer.prototype, "folders", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Map)
], QboFileExplorer.prototype, "files", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Object)
], QboFileExplorer.prototype, "currentFile", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboFileExplorer.prototype, "sortBy", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboFileExplorer.prototype, "pattern", void 0);
__decorate([
    property(),
    __metadata("design:type", String)
], QboFileExplorer.prototype, "sortDirection", void 0);
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Array)
], QboFileExplorer.prototype, "history", void 0);
__decorate([
    state(),
    __metadata("design:type", Array)
], QboFileExplorer.prototype, "mappings", void 0);
if (!customElements.get('qbo-file-explorer'))
    customElements.define('qbo-file-explorer', QboFileExplorer);
